module.exports = __webpack_public_path__ + "cf786c9dfa35ff943732420c0f1d56e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/printOnline.png
// module id = 271
// module chunks = 0